import Setup from "../components/election/Setup";
import Eligible from "../components/voter/Eligible";
import Election from "../components/election/Election";
import Elections from "../components/election/Elections";
import ElectionVoters from "../components/voter/ElectionVoters";

const routes = [
  {
    path: "/setup",
    name: "setup",
    component: Setup,
    meta: { requiresAuth: true, description: "Set up new election" },
  },
  {
    path: "/elections",
    name: "elections",
    component: Elections,
    meta: {
      requiresAuth: true,
      description: "Elections - past, present and future",
    },
  },
  {
    props: true,
    path: "/elections/:election",
    name: "election",
    component: Election,
    meta: {
      requiresAuth: true,
      description: "Details of election",
    },
  },
  {
    props: true,
    path: "/elections/:election/eligible",
    name: "eligible",
    component: Eligible,
    meta: {
      requiresAuth: true,
      description: "Select eligible voters for election",
    },
  },
  {
    props: true,
    path: "/elections/:election/voters",
    name: "voters",
    component: ElectionVoters,
    meta: {
      requiresAuth: true,
      description: "Voter list for this election",
    },
  },
];

export default routes;
